/**
 * Меню админки.
 *
 * Секции задаются элементом с `title: true` — второй уровень сайдбара плоский,
 * раскрывающихся подменю компонент не рисует (см. SidebarContent).
 *
 * Раздел «Настройки» разросся до четырнадцати пунктов, в которых лежали вперемешку
 * биллинг, SMS, задачи и системные инструменты, — разложено по смыслу. Правило
 * простое: в секции не больше шести пунктов, иначе её перестают читать и начинают
 * искать глазами по всему списку.
 *
 * `permission` — право из категории «Админка» (`permissions.value`). Раньше админ был
 * один и видел всё; теперь в админке работают продажники и операторы, у каждого свой
 * набор разделов. Сайдбар прячет пункты без права, маршрут — закрывает вход по прямой
 * ссылке, а сервер проверяет то же право middleware `permissions:<value>`.
 */
export let exportMenu = [
	{
		icon: "uil-setting sidebar-icon",
		children: [
			{
				title: true,
				i18n: "overview",
			},
			{
				url: "/admin/analytics",
				i18n: "admin_analytics",
				icon: "uil-chart-line",
				permission: "admin_analytics",
				active: false,
			},
			{
				url: "/admin/ai-support",
				i18n: "admin_ai_support",
				icon: "uil-robot",
				permission: "admin_ai_support",
				active: false,
			},
			{
				title: true,
				i18n: "clients",
			},
			{
				url: "/admin/users",
				i18n: "users",
				icon: "uil-users-alt",
				permission: "admin_users",
				active: false,
			},
			{
				url: "/admin/poses",
				i18n: "pos",
				icon: "uil-shop",
				permission: "admin_poses",
				active: false,
			},
			{
				url: "/admin/pos-status-history",
				i18n: "pos_status_history",
				icon: "uil-history",
				permission: "admin_pos_status_history",
				active: false,
			},
			{
				// Список точек, у которых что-то не настроено: по нему звонят первыми,
				// не дожидаясь жалобы «у нас не приходят заказы»
				url: "/admin/setup-health",
				i18n: "admin_setup_health",
				icon: "uil-check-circle",
				permission: "admin_poses",
				active: false,
			},
			{
				// Кого давно не обзванивали и кто перестал пробивать чеки: список
				// на обзвон, пока клиент ещё не сказал «мы решили не продолжать»
				url: "/admin/pos-care",
				i18n: "admin_pos_care",
				icon: "uil-heart",
				permission: "admin_pos_care",
				active: false,
			},
			{
				url: "/admin/pos-calls",
				i18n: "admin_pos_calls",
				icon: "uil-phone",
				permission: "admin_pos_calls",
				active: false,
			},
			{
				title: true,
				i18n: "partners",
			},
			{
				url: "/admin/partners",
				i18n: "partners",
				icon: "uil-users-alt",
				permission: "admin_partners",
				active: false,
			},
			{
				url: "/admin/partner-connections",
				i18n: "admin_partner_connections",
				icon: "uil-plug",
				permission: "admin_partner_connections",
				active: false,
			},
			{
				url: "/admin/partner-bonus-distribution",
				i18n: "admin_partner_bonus_distribution",
				icon: "uil-percentage",
				permission: "admin_partner_bonus_distribution",
				active: false,
			},
			{
				url: "/admin/partner-bonus-accrual",
				i18n: "admin_partner_bonus_accrual",
				icon: "uil-money-bill",
				permission: "admin_partner_bonus_accrual",
				active: false,
			},
			{
				url: "/admin/partner-bonus-histories",
				i18n: "admin_partner_bonus_histories",
				icon: "uil-bill",
				permission: "admin_partner_bonus_histories",
				active: false,
			},
			{
				url: "/admin/partner-payments",
				i18n: "partner_payments",
				icon: "uil-history",
				permission: "admin_partner_payments",
				active: false,
			},
			{
				title: true,
				i18n: "billing",
			},
			{
				url: "/admin/payments-history",
				i18n: "payment_history",
				icon: "uil-history",
				permission: "admin_payments_history",
				active: false,
			},
			{
				url: "/admin/pos-subscriptions",
				i18n: "pos_subscriptions",
				icon: "uil-apps",
				permission: "admin_poses",
				active: false,
			},
			{
				url: "/admin/subscription-services",
				i18n: "admin_subscription_services",
				icon: "uil-bill",
				permission: "admin_subscription_services",
				active: false,
			},
			{
				title: true,
				i18n: "sms",
			},
			{
				url: "/admin/sms-upstreams",
				i18n: "sms_upstreams",
				icon: "uil-share-alt",
				permission: "admin_sms_upstreams",
				active: false,
			},
			{
				url: "/admin/sms-prices",
				i18n: "sms_prices",
				icon: "uil-money-bill",
				permission: "admin_sms_prices",
				active: false,
			},
			{
				url: "/admin/sms-templates",
				i18n: "sms_templates_catalog",
				icon: "uil-comment-alt-lines",
				permission: "admin_sms_templates",
				active: false,
			},
			{
				url: "/admin/sms-report",
				i18n: "sms_report",
				icon: "uil-chart-line",
				permission: "admin_sms_report",
				active: false,
			},
			{
				title: true,
				i18n: "tasks",
			},
			{
				url: "/admin/task-categories",
				i18n: "task_categories",
				icon: "uil-list-ul",
				permission: "admin_task_categories",
				active: false,
			},
			{
				url: "/admin/tasks",
				i18n: "tasks",
				icon: "uil-check-square",
				permission: "admin_tasks",
				active: false,
			},
			{
				title: true,
				i18n: "system",
			},
			{
				url: "/admin/administrators",
				i18n: "administrators",
				icon: "uil-shield-check",
				permission: "admin_administrators",
				active: false,
			},
			{
				url: "/admin/sql",
				i18n: "pos_monitor",
				icon: "uil-monitor",
				permission: "admin_sql",
				active: false,
			},
			{
				// Состояние наших сервисов и журнал синхронизаций по всем точкам:
				// сюда идут с вопросом «почему у клиента касса не синхронизировалась»
				url: "/admin/system-health",
				i18n: "admin_system_health",
				icon: "uil-heart-medical",
				permission: "admin_system_health",
				active: false,
			},
			{
				url: "/admin/duplicate",
				i18n: "admin_tools",
				icon: "uil-wrench",
				permission: "admin_duplicate",
				active: false,
			},
			{
				url: "/admin/permissions",
				i18n: "permissions",
				icon: "uil-lock",
				permission: "admin_permissions",
				active: false,
			},
			{
				url: "/admin/navigations",
				i18n: "navigations",
				icon: "uil-list-ui-alt",
				permission: "admin_navigations",
				active: false,
			},
			{
				url: "/admin/languages",
				i18n: "languages",
				icon: "uil-english-to-chinese",
				permission: "admin_languages",
				active: false,
			},
			{
				url: "/admin/versions",
				i18n: "versions",
				icon: "uil-mobile-android-alt",
				permission: "admin_versions",
				active: false,
			},
			{
				url: "/admin/mobile-apps",
				i18n: "admin_mobile_apps",
				icon: "uil-bell",
				permission: "admin_mobile_apps",
				active: false,
			},
		]
	},
]

/**
 * Все пункты меню одним списком — сайдбар рисует их по секциям, а маршрутам и
 * домашней странице нужен именно плоский перебор.
 */
export function adminMenuItems() {
	const items = []

	for (let i = 0; i < exportMenu.length; i++) {
		const children = exportMenu[i].children || []

		for (let j = 0; j < children.length; j++) {
			if (children[j].url) {
				items.push(children[j])
			}
		}
	}

	return items
}

/**
 * Право, закрывающее страницу админки. Сопоставление идёт по началу пути: у карточек
 * вида /admin/poses/15 право то же, что у списка.
 */
export function adminPermissionByPath(pathname) {
	if (!pathname) {
		return null
	}

	const items = adminMenuItems()
	let matched = null

	for (let i = 0; i < items.length; i++) {
		if (pathname === items[i].url || pathname.indexOf(items[i].url + '/') === 0) {
			// Побеждает самый длинный совпавший url: /admin/pos-status-history не должен
			// достаться правилу /admin/pos.
			if (!matched || items[i].url.length > matched.url.length) {
				matched = items[i]
			}
		}
	}

	return matched ? matched.permission : null
}
